import { useQuery } from "@tanstack/react-query";
import {
	getSawEntryQueue,
	type SawEntryQueueData,
} from "../repositories/sawEntryQueueRepository";

export const sawEntryQueueKey = (assetId: number) =>
	["sawEntryQueue", assetId] as const;

export const useSawEntryQueue = (assetId: number) => {
	return useQuery<SawEntryQueueData, Error>({
		queryKey: sawEntryQueueKey(assetId),
		queryFn: () => getSawEntryQueue(assetId),
		meta: { realtime: ["FAB.GetSawEntryQueue"] },
		enabled: assetId > 0,
		refetchInterval: 10000,
		refetchOnWindowFocus: true,
		refetchOnReconnect: true,
		retry: false,
	});
};
